<template>
  <CRow class="px-0 mx-0">
    <CCol col="12" md="5" lg="4">
      <CRow class="mfe-md-1">
        <CCol col="12" class="b-a-1 bg-white px-0">
          <table class="table table-borderless m-0">
            <tbody>
              <tr>
                <td>شماره فاکتور</td>
                <td class="font-weight-bolder text-left">{{ invoice.number || '-' }}</td>
              </tr>
              <tr>
                <td>وضعیت</td>
                <td class="font-weight-bolder text-left">{{ invoiceStatusStr(invoice.status) }}</td>
              </tr>
              <tr>
                <td>تاریخ شروع</td>
                <td class="font-weight-bolder text-left">{{ invoice.started_at ? $moment(invoice.started_at).format('L') : '-' }}</td>
              </tr>
              <tr>
                <td>تاریخ پایان</td>
                <td class="font-weight-bolder text-left">{{ invoice.finished_at ? $moment(invoice.finished_at).format('L') : '-' }}</td>
              </tr>
            </tbody>
          </table>
        </CCol>
        <CCol col="12" class="b-a-1 mt-2 bg-white px-0" v-if="invoice.contact">
          <table class="table table-borderless m-0">
            <tbody>
              <tr>
                <td>مشخصات {{ isReal() ? 'حقیقی' : 'حقوقی' }}</td>
                <td></td>
              </tr>
              <tr>
                <td>{{ isReal() ? 'نام و نام خانوادگی' : 'نام شرکت' }}</td>
                <td class="font-weight-bolder text-left">{{ invoice.contact.name || '-' }}</td>
              </tr>
              <tr>
                <td>{{ isReal() ? 'کد ملی' : 'شناسه ملی' }}</td>
                <td class="font-weight-bolder text-left">{{ invoice.contact.national_id || '-' }}</td>
              </tr>
              <tr>
                <td>{{ 'شماره تماس' }}</td>
                <td class="font-weight-bolder text-left">{{ invoice.contact.phone || '-' }}</td>
              </tr>
            </tbody>
          </table>

        </CCol>
      </CRow>
    </CCol>
    <CCol col="12" md="7" lg="8" class="b-a-1 bg-white p-2 p-md-3 mt-md-0 mt-3">
      <CRow class="justify-content-end">
        <CCol col="12" class="py-3">
          <div class="table-responsive">
            <table class="table table-borderless m-0" style="min-width:450px;">
              <tbody>
                <tr v-for="item, index in invoice.items" :key="index">
                  <td class="text-center">
                    <span class="py-2 px-3 bg-gray-200 text-black font-weight-bold" style="border-radius: 3px;">{{ index + 1 }}</span>
                  </td>
                  <td class="text-right">{{ item.name }}</td>
                  <td class="text-center">جمع <span class="p-2 font-xs text-primary font-weight-bolder" style="background-color:rgb(132 18 209 / 25%);border-radius: 3px;">{{ $numberWithCommas(item.amount) }} {{$t('rial')}}</span></td>
                  <td class="text-center text-primary">
                    <span class="cursor-pointer" @click="openDetailsModal(item.slug)">
                      جزئیات
                      <FaIcon icon="angle-left" class="font-xs"></FaIcon>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </CCol>
        <CCol col="12" md="12" lg="6">
          <CCard class="mt-3" style="background-color:rgb(132 18 209 / 15%);border-color:rgb(132 18 209/ 25%);">
            <table class="table table-borderless m-0 inv-tbl">
              <tbody>
                <tr>
                  <td>مجموع مبالغ فاکتور:</td>
                  <td class="font-weight-bolder text-left">{{ $numberWithCommas(invoice.amount) || 0 }}</td>
                </tr>
                <tr>
                  <td>تخفیف</td>
                  <td class="font-weight-bolder text-left">{{ $numberWithCommas(invoice.discount) || 0 }}</td>
                </tr>
                <tr>
                  <td>ارزش افزوده و مالیات</td>
                  <td class="font-weight-bolder text-left">{{ $numberWithCommas(invoice.tax) || 0 }}</td>
                </tr>
                <tr class="bg-primary" style="height:2px;">
                  <td style="padding-top: 0.25rem!important;padding-bottom: 0!important;"></td>
                  <td style="padding-top: 0.25rem!important;padding-bottom: 0!important;"></td>
                </tr>
                <tr>
                  <td>مبلغ نهایی:</td>
                  <td class="font-weight-bolder text-left">{{ $numberWithCommas(totalPayableAmount || 0) }}</td>
                </tr>
              </tbody>
            </table>
          </CCard>
        </CCol>
      </CRow>
    </CCol>
    <CModal color="affili-info" :show.sync="conversionModal.show" size="xl">
      <template #header-wrapper>
        <span></span>
      </template>

      <CRow>
        <CDataTable
            class="col-12 px-0"
            :items="Object.values(conversionModal.items)"
            :fields="$dataTableFieldsMaker(conversionFields)"
            hover
            :pagination="{...conversionModal.pagination, change: fetchConversions}"
            addTableClasses="bg-white"
        >
          <template #storeName="{item}">
            <td>
              {{ item.store.name }}
            </td>
          </template>

          <template #type="{item}">
            <td>
              {{ conversionTypeStr(item.type) }}
            </td>
          </template>

          <template #user="{item}">
            <td>
              {{ item.user ? item.user.full_name : '' }}
            </td>
          </template>

          <template #wage="{item}">
            <td class="ltr font-weight-bold">
              {{ item.wage ? $numberWithCommas(item.wage) : '' }}
            </td>
          </template>

          <template #link="{item}">
            <td>
              <span v-if="item.link && item.link.title" :title="item.link.title">
                {{ item.link.title.length > 12 ? item.link.title.substring(0, 12)+'...' : item.link.title }}
              </span>
              <span v-else>
                {{ $t('undefined') }}
              </span>
            </td>
          </template>

          <template #createdAt="{item}">
            <td>
              {{ $moment(item.created_at).format('LL') }}
            </td>
          </template>

          <template #checkedOutAt="{item}">
            <td>
              {{ item.checked_out_at ? $moment(item.checked_out_at).format('LL') : '-' }}
            </td>
          </template>

          <template #amount="{item}">
            <td class="font-weight-bold"
              v-if="item.type == ConversionType.LEAD"
            >
              <span
                class="badge badge-affili-eggplant text-center"
              >{{ $t('conversion.types.lead') }}</span>
            </td>
            <td class="ltr font-weight-bold"
              v-else
            >
              {{ item.amount ? $numberWithCommas(item.amount) : '' }}
            </td>
          </template>

          <template #commissionAmount="{item}">
            <td class="ltr font-weight-bold">
              {{ $numberWithCommas(item.commission_amount) }}
            </td>
          </template>

          <template #externalId="{item}">
            <td>
              {{ item.external_id || '' }}
            </td>
          </template>

          <template #status="{item}">
            <td>
              <span :class="'badge badge-'+conversionStatusColor(item.status)">
                {{ conversionStatusStr(item.status) }}
                <span v-if="item.is_closed">(قطعی)</span>
              </span>
            </td>
          </template>

        </CDataTable>
      </CRow>

      <template #footer-wrapper>
        <div></div>
      </template>
    </CModal>
  </CRow>
</template>

<script>
import { mapGetters } from 'vuex'
import { invoiceStatusStr } from './partials/invoice/methods'
import { ContactType } from '@/constants'
import { conversionService } from '@/services/api'
import { fieldsWithoutActions as conversionFields } from './../conversions/partials/fields'
import { conversionStatusStr, conversionTypeStr, conversionStatusColor } from './../conversions/partials/methods'
import { ConversionType } from '@/constants'

export default {
  name: 'InvoiceDetails',

  data() {
    return {
      conversionFields,
      conversionStatusStr,
      conversionTypeStr,
      conversionStatusColor,
      ConversionType,
      id: this.$route.params.id,
      conversionModal: {
        items: [],
        pagination: {
          per_page: 20,
          current_page: 1,
          last_page: 1,
        },
        show: false,
      }
    }
  },

  computed: {
    ...mapGetters({
      invoiceById: 'invoice/invoiceById',
    }),

    invoice() {
      return this.invoiceById(this.id)
    },
    totalPayableAmount() {
      return parseFloat(this.invoice.amount) + parseFloat(this.invoice.tax) - parseFloat(this.invoice.discount)
    }
  },

  methods: {
    invoiceStatusStr,
    openDetailsModal(slug) {
      // we show conversions of this invoice
      if (slug === 'affiliate-marketing-service') {
        this.conversionModal = {
          items: [],
          show: true,
          pagination: {
            per_page: 20,
            current_page: 1,
            last_page: 1,
          }
        }
        this.fetchConversions()
      }
    },
    fetchConversions(page = 1) {
      conversionService.fetch({
          invoice_id: this.invoice.real_id,
          page: page
        }).then(res => {
          const result = res.data

          this.conversionModal.items = result.data
          this.conversionModal.pagination = {
            per_page: result.per_page,
            current_page: result.current_page,
            last_page: result.last_page,
          }
        })
    },
    isReal() {
      return this.invoice && parseInt(this.invoice.contact.type) === ContactType.REAL
    }
  }
}
</script>

<style scoped lang="scss">
.inv-tbl::v-deep td {
  padding-top: .5rem!important;
  padding-bottom: .5rem!important;
}
</style>